<div
  class="flex flex-col justify-between h-[12.25rem]"
  [class]="direction"
  [ngClass]="isMobile ? 'w-full' : 'w-[25rem]'"
  >
  <div>
    <!--
      a11y: close button reordered to be FIRST in DOM (via tailwind order-2,
      order-1 keeps the visual layout: heading on the leading side, X on the
      trailing side). [focusInitial]=true makes the CDK focus trap put initial
      focus here. Rendered for mobile too (was desktop-only) so all viewports
      satisfy the audit requirement.
    -->
    <div class="flex justify-between">
      <mot-button
        matType="icon"
        icon="close"
        [ariaLabel]="closeText"
        class="!border-none !w-min !h-min cursor-pointer !bg-transparent order-2"
        iconClass="!text-2xl"
        [focusInitial]="true"
        (onClick)="closeCard()"
        />

      <div class="flex items-center gap-2 order-1">
        <ng-icon [name]="'circle-info'" class="text-xl" aria-hidden="true"></ng-icon>
        @if (data.isForOrderSeat) {
          <h2 class="m-0 text-base font-normal">
            {{ orderSeatText }}
          </h2>
        }
        @if (!data.isForOrderSeat) {
          <h2 class="m-0 text-base font-normal">
            {{ contactInfoText }} - {{ agencyDisplayName }}
          </h2>
        }
      </div>
    </div>
    @if (contactInfo) {
      <div class="flex flex-col gap-2">
        @if (data.isForOrderSeat) {
          <p class="font-normal m-0">
            {{ pleaseContactWithText }} {{ agencyDisplayName }} {{ inNumberText }}
            {{ orInWebsiteText }}:
          </p>
        }
        <p class="font-normal m-0">
          {{ phoneNumberText }} -
          <span dir="ltr">{{ contactInfo.agencyPhone }}</span>
        </p>
        <p class="font-normal m-0">
          {{ websiteText }} -
          <a
            href="{{ contactInfo.agencyWebsite }}"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="agencyWebsiteLinkAriaLabel"
            [attr.title]="agencyWebsiteLinkAriaLabel"
            >{{ contactInfo.agencyWebsite }}</a
            >
          </p>
        </div>
      }
    </div>

    @if (isDesktop) {
      <div class="!flex justify-end !sticky bottom-2 px-2">
        <mot-button
          [text]="closeText"
          buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5"
          (onClick)="closeCard()"
          />
        </div>
      }
    </div>
